import { render } from "./ResultScreen.vue?vue&type=template&id=5c865ae0&scoped=true"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"

import "./ResultScreen.vue?vue&type=style&index=0&id=5c865ae0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c865ae0"]])

export default __exports__